import { render } from "./AppTop.vue?vue&type=template&id=f8c39818"
import script from "./AppTop.vue?vue&type=script&lang=js"
export * from "./AppTop.vue?vue&type=script&lang=js"

import "./AppTop.vue?vue&type=style&index=0&id=f8c39818&lang=css"
script.render = render

export default script